// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.description_scroll[data-v-20251197] {\n  max-height: 100px;\n  overflow-y: auto;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
